import { render, staticRenderFns } from "./loginborrow.vue?vue&type=template&id=07d433a8&scoped=true"
import script from "./loginborrow.vue?vue&type=script&lang=js"
export * from "./loginborrow.vue?vue&type=script&lang=js"
import style0 from "./loginborrow.vue?vue&type=style&index=0&id=07d433a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d433a8",
  null
  
)

export default component.exports